import SelectController from "./select_controller";

export default class extends SelectController {
  initSelect2() {
    $(this.element).select2({
      width: "100%",
      allowClear: this.allowClearValue,
      placeholder: this.placeholderValue,
      templateResult: this.template,
      templateSelection: this.template
    });
  }

  template(r){
    if (!r.id) return r.text
    if (r.id.includes('Group')) return $(`<span><i class=\"fa fa-home\"></i> ${r.text}</span>`)
    if (r.id.includes('User')) return $(`<span><i class=\"fa fa-user\"></i> ${r.text}</span>`)
  }
}
